var _circle, _rect, _g, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWomanWithKey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 296 289",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 237.026,
    cy: 47.1767,
    r: 22.417,
    fill: "#D9E8F2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 184.843,
    y: 0.328125,
    width: 111.157,
    height: 199.832,
    rx: 8.22861,
    fill: "#F4F6FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1515_10264)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 240.423,
    cy: 43.2041,
    r: 22.417,
    fill: "#D9E8F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.125 57.463C225.016 52.5883 229.318 49.3381 234.726 48.0216C235.69 47.7868 236.118 46.1846 235.505 45.4037C233.854 43.3016 232.804 40.4041 232.804 38.0897C232.804 33.9563 236.155 30.6055 240.288 30.6055C244.422 30.6055 247.772 33.9563 247.772 38.0897C247.772 40.3876 246.737 43.2605 245.107 45.3588C244.497 46.1437 244.938 47.7454 245.906 47.9708C251.414 49.2532 255.804 52.5245 257.72 57.4632C253.609 62.445 247.387 65.6204 240.423 65.6204C233.459 65.6204 227.237 62.4449 223.125 57.463Z",
    fill: "#BADDF4"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 228.696,
    y: 6.10938,
    width: 25.6194,
    height: 2.40182,
    rx: 1.20091,
    fill: "#C5CFD6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 199.944,
    y: 5.70898,
    width: 3.20242,
    height: 3.20242,
    rx: 1.60121,
    fill: "#C5CFD6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 213.836,
    y: 79.0703,
    width: 53.1716,
    height: 3.20242,
    rx: 1.60121,
    fill: "#D9E8F2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 205.223,
    y: 85.8438,
    width: 70.3971,
    height: 3.20242,
    rx: 1.60121,
    fill: "#D9E8F2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 199.387,
    y: 108.947,
    width: 82.0703,
    height: 12.8097,
    rx: 4.1143,
    fill: "#D9E8F2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 199.387,
    y: 131.678,
    width: 82.0703,
    height: 12.8097,
    rx: 4.1143,
    fill: "#D9E8F2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.506,
    cy: 185.662,
    r: 8.00606,
    fill: "#E8ECF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M212.684 115.344L214.652 116.452L214.139 117.362L212.138 116.187L212.155 118.437H211.162L211.179 116.187L209.178 117.362L208.665 116.452L210.65 115.344L208.665 114.252L209.178 113.326L211.179 114.5L211.162 112.268H212.155L212.138 114.5L214.139 113.326L214.652 114.252L212.684 115.344Z",
    fill: "#94CFF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M224.251 115.344L226.219 116.452L225.706 117.362L223.705 116.187L223.722 118.437H222.729L222.746 116.187L220.745 117.362L220.232 116.452L222.217 115.344L220.232 114.252L220.745 113.326L222.746 114.5L222.729 112.268H223.722L223.705 114.5L225.706 113.326L226.219 114.252L224.251 115.344Z",
    fill: "#94CFF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M235.818 115.344L237.786 116.452L237.273 117.362L235.272 116.187L235.288 118.437H234.296L234.313 116.187L232.311 117.362L231.799 116.452L233.783 115.344L231.799 114.252L232.311 113.326L234.313 114.5L234.296 112.268H235.288L235.272 114.5L237.273 113.326L237.786 114.252L235.818 115.344Z",
    fill: "#94CFF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M247.384 115.344L249.353 116.452L248.84 117.362L246.839 116.187L246.855 118.437H245.863L245.879 116.187L243.878 117.362L243.365 116.452L245.35 115.344L243.365 114.252L243.878 113.326L245.879 114.5L245.863 112.268H246.855L246.839 114.5L248.84 113.326L249.353 114.252L247.384 115.344Z",
    fill: "#94CFF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M258.951 115.344L260.919 116.452L260.407 117.362L258.405 116.187L258.422 118.437H257.43L257.446 116.187L255.445 117.362L254.932 116.452L256.917 115.344L254.932 114.252L255.445 113.326L257.446 114.5L257.43 112.268H258.422L258.405 114.5L260.407 113.326L260.919 114.252L258.951 115.344Z",
    fill: "#94CFF5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M270.518 115.344L272.486 116.452L271.973 117.362L269.972 116.187L269.989 118.437H268.996L269.013 116.187L267.012 117.362L266.499 116.452L268.484 115.344L266.499 114.252L267.012 113.326L269.013 114.5L268.996 112.268H269.989L269.972 114.5L271.973 113.326L272.486 114.252L270.518 115.344Z",
    fill: "#94CFF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M212.684 138.074L214.652 139.182L214.139 140.092L212.138 138.918L212.155 141.167H211.162L211.179 138.918L209.178 140.092L208.665 139.182L210.65 138.074L208.665 136.983L209.178 136.057L211.179 137.231L211.162 134.998H212.155L212.138 137.231L214.139 136.057L214.652 136.983L212.684 138.074Z",
    fill: "#94CFF5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M224.251 138.074L226.219 139.182L225.706 140.092L223.705 138.918L223.722 141.167H222.729L222.746 138.918L220.745 140.092L220.232 139.182L222.217 138.074L220.232 136.983L220.745 136.057L222.746 137.231L222.729 134.998H223.722L223.705 137.231L225.706 136.057L226.219 136.983L224.251 138.074Z",
    fill: "#94CFF5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M235.818 138.074L237.786 139.182L237.273 140.092L235.272 138.918L235.288 141.167H234.296L234.313 138.918L232.311 140.092L231.799 139.182L233.783 138.074L231.799 136.983L232.311 136.057L234.313 137.231L234.296 134.998H235.288L235.272 137.231L237.273 136.057L237.786 136.983L235.818 138.074Z",
    fill: "#94CFF5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M247.384 138.074L249.353 139.182L248.84 140.092L246.839 138.918L246.855 141.167H245.863L245.879 138.918L243.878 140.092L243.365 139.182L245.35 138.074L243.365 136.983L243.878 136.057L245.879 137.231L245.863 134.998H246.855L246.839 137.231L248.84 136.057L249.353 136.983L247.384 138.074Z",
    fill: "#94CFF5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M258.951 138.074L260.919 139.182L260.407 140.092L258.405 138.918L258.422 141.167H257.43L257.446 138.918L255.445 140.092L254.932 139.182L256.917 138.074L254.932 136.983L255.445 136.057L257.446 137.231L257.43 134.998H258.422L258.405 137.231L260.407 136.057L260.919 136.983L258.951 138.074Z",
    fill: "#94CFF5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M270.518 138.074L272.486 139.182L271.973 140.092L269.972 138.918L269.989 141.167H268.996L269.013 138.918L267.012 140.092L266.499 139.182L268.484 138.074L266.499 136.983L267.012 136.057L269.013 137.231L268.996 134.998H269.989L269.972 137.231L271.973 136.057L272.486 136.983L270.518 138.074Z",
    fill: "#94CFF5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.349 23C95.0897 23 88.3945 29.6951 88.3945 37.954V50.5625C88.3945 58.0536 93.9028 64.2582 101.09 65.347C101.093 65.4079 101.097 65.469 101.1 65.5303H120.374C123.652 62.3294 119.948 40.618 117.638 33.4224C117.307 32.391 116.986 31.6534 116.671 31.1556C114.196 26.3143 109.159 23 103.349 23Z",
    fill: "#131B4B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.639 55.0485C107.943 57.6415 112.171 58.8944 114.157 58.383C119.134 57.1005 119.592 38.8995 115.74 31.7241C111.889 24.5487 92.0898 21.4212 91.0918 35.638C90.7454 40.572 92.8181 44.9753 95.8804 48.5684L90.3892 74.1511H106.34L103.639 55.0485Z",
    fill: "#F0C6A3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.9807 35.7209C89.4439 35.2631 89.8921 34.8202 90.3367 34.4237L90.3153 33.9083C90.3153 33.9083 95.3216 23.6641 103.018 23.6641C110.707 23.6641 113.139 27.2372 115.206 30.2746L115.212 30.2827C114.131 33.9911 110.872 35.4914 107.187 37.1882C105.6 37.9187 103.934 38.6856 102.329 39.6808C101.701 39.1703 100.899 38.8643 100.026 38.8643C98.0071 38.8643 96.3705 40.5002 96.3705 42.5181C96.3705 44.536 98.0071 46.1719 100.026 46.1719C100.082 46.1719 100.137 46.1706 100.192 46.1681C100.927 54.0587 100.632 63.069 98.4423 65.2079H79.1683C78.615 55.5991 81.1018 52.8581 83.6429 50.0572C86.0339 47.4217 88.473 44.7332 88.473 36.2208C88.6445 36.0532 88.8136 35.8861 88.9807 35.721L88.9807 35.7209Z",
    fill: "#131B4B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0718 129.289L109.417 213.144L120.868 276.104H132.362L120.889 129.289H85.0718Z",
    fill: "#F0C6A3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0718 129.289L109.417 213.144L120.868 276.104H132.362L120.889 129.289H85.0718Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.1305 129.289C75.8293 172.851 75.1593 196.611 74.7791 200.569C74.3989 204.527 72.2405 231.034 57.5322 277.432H69.4863C88.965 232.921 95.7648 206.414 97.9988 200.569C100.233 194.724 106.831 170.964 116.464 129.289H74.1305Z",
    fill: "#F0C6A3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5493 129.289C90.882 158.144 101.835 204.203 117.408 267.468H134.218C135.46 202.533 130.178 159.795 121.031 129.289H84.5493Z",
    fill: "#5A6AD4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.0457 129.289C75.7094 172.851 71.3978 215.768 58.042 268.146H75.9777C95.4921 224.299 109.479 181.593 119.038 129.289H74.0457Z",
    fill: "#9CA6E5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8286 286.069L56.3994 276.872C56.4449 276.138 57.1608 275.635 57.8863 275.753C63.5833 276.682 70.9991 274.111 70.9991 274.111C78.3768 279.335 88.7606 281.951 93.5109 282.935C94.8615 283.215 95.7308 284.584 95.3544 285.911L94.7442 288.062H70.9991H57.1478L55.8286 286.069Z",
    fill: "#131B4B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.302 286.069L118.873 276.872C118.919 276.138 119.634 275.635 120.36 275.753C126.057 276.682 133.473 274.111 133.473 274.111C140.85 279.335 151.234 281.951 155.985 282.935C157.335 283.215 158.204 284.584 157.828 285.911L157.218 288.062H133.473H119.621L118.302 286.069Z",
    fill: "#131B4B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.229 102.927L168.47 99.3491C173.719 96.4306 178.549 94.4549 182.958 93.4219C184.198 93.3857 186.172 93.8365 183.232 96.2866C180.291 98.7367 177.308 101.447 177.832 102.755C178.356 104.062 181.09 103.576 181.543 105.587C181.845 106.928 177.407 107.145 168.23 106.24L146.937 114.678L142.229 102.927Z",
    fill: "#F0C6A3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.6595 62.859L111.054 63.6177C113.861 88.9955 129.147 105.025 163.371 99.5985L167.918 132.28C135.93 136.412 107.877 123.611 102.127 88.9524C100.639 79.9804 99.4637 70.6433 99.6595 62.859Z",
    fill: "#00E2DA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.1089 133.941H125.614C120.762 112.118 111.303 93.1812 111.303 63.5L93.9921 59.5371C81.5448 78.6983 75.567 102.29 73.1089 133.941Z",
    fill: "#B8FFFD"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.9863 133.943C80.3236 118.59 82.7115 104.107 86.6591 90.4941C85.7938 105.052 85.5536 123.113 88.4631 133.943H78.9863Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.75 92.8763C215.291 101.04 211.95 110.161 204.234 114.616C195.289 119.78 183.85 116.715 178.685 107.77C173.52 98.8241 176.585 87.3854 185.531 82.2206C193.246 77.7663 202.816 79.4334 208.615 85.7148L247.025 63.539L251.16 70.7006L251.159 70.7007L255.698 78.5611L250.837 81.3676L246.298 73.5072L242.146 75.9047L246.684 83.7653L241.823 86.5718L237.285 78.7112L212.75 92.8763ZM203.622 93.373C200.835 88.5465 194.664 86.8928 189.837 89.6794C185.011 92.466 183.357 98.6375 186.144 103.464C188.93 108.29 195.102 109.944 199.928 107.158C204.755 104.371 206.408 98.1994 203.622 93.373Z",
    fill: "#FFAA00"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.912 113.221L176.094 109.228C181.296 106.226 186.093 104.174 190.485 103.072C191.725 103.016 193.706 103.435 190.805 105.932C187.903 108.428 184.963 111.185 185.508 112.484C186.052 113.783 188.779 113.254 189.264 115.257C189.587 116.593 185.153 116.881 175.962 116.122L154.806 124.896L149.912 113.221Z",
    fill: "#F0C6A3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.9548 72.4784L106.36 73.0565C109.594 99.8867 136.865 115.529 170.999 109.561L176.063 142.166C144.145 146.804 105.307 135.874 99.0095 101.311C97.3792 92.3637 94.8823 80.2649 94.9548 72.4784Z",
    fill: "#B8FFFD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1515_10264",
    x: 205.663,
    y: 12.5585,
    width: 69.5198,
    height: 69.5198,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.1143
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.17146
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0548611 0 0 0 0 0.0934353 0 0 0 0 0.329167 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1515_10264"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1515_10264",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanWithKey);
export default __webpack_public_path__ + "static/media/woman_with_key.fe46c7930fe64732191ead6ac133f99d.svg";
export { ForwardRef as ReactComponent };